import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './favouriteproductitem.module.css';
import ImageWithFallback from '../ImageWithFallback';

const FavouriteProductItem = () => {
    return (
        <div className={`card mb-4 ${styles.productCard}`}>
            <div className="row no-gutters">
                <div className="col-md-3">
                    <ImageWithFallback loading="lazy" src="https://bootstrapious.com/i/snippets/sn-cart/product-2.jpg" className={`card-img ${styles.productImage}`} alt="Product" />
                </div>
                <div className="col-md-9">
                    <div className="card-body">
                        <h5 className="card-title">Áo nam</h5>
                        <div className="d-flex align-items-center mb-2">
                            <span className={`text-warning ${styles.rating}`}>4.5 <i className="fas fa-star"></i></span>
                            <span className={`text-muted ${styles.info}`}>1280 Lượt mua</span>
                            <span className={`text-muted ${styles.info}`}>1280 Đánh giá</span>
                        </div>
                        <p className="card-text">
                            <strong className={styles.price}>499,000 đ</strong>
                        </p>
                        <p className="card-text text-muted">Mã giảm giá của shop</p>
                        <div className="mb-2">
                            <span className={`badge ${styles.discountBadge}`}>18% Giảm</span>
                            <span className={`badge ${styles.discountBadge}`}>18% Giảm</span>
                            <span className={`badge ${styles.discountBadge}`}>18% Giảm</span>
                            <span className={`text-muted ${styles.viewAll}`}>Xem tất cả </span>
                        </div>
                        <button className={`btn btn-outline-dark ${styles.similarProductsButton}`}>Sản phẩm tương tự</button>
                        <button className={`btn btn-warning ${styles.addToCartButton}`}>Thêm vào giỏ hàng</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FavouriteProductItem;


